// extracted by mini-css-extract-plugin
export default {"container":"page-wrapper-with-common-blocks_container__f0PMb"};